/**
 * Replace all DOM elements with data attribute data-number-formatted
 * using the value from attribute and replace in tag formatted value.
 *
 * @author Stefan Lazarevic <stefan.l@scopicsoftware.com>
 * @since 02.04.2018
 */
;(function PhoneNumberFormater(global) {

        /**
         * Format phone number string in x (xxx) xxx xxxx format.
         * @param {String} number Number to format
         * @return {String} Phone number in format x (xxx) xxx xxxx
         */
        function formatNumber(number) {
            if (typeof number === 'string') {
                if (number === 'N/A') {
                    return number;
                }

                let numberArray = number.replace(/\D/g,'').split('');
                let formattedNumber = numberArray.slice(-4).join('');
                formattedNumber = numberArray.slice(-7, -4).join('') + ' ' + formattedNumber;
                formattedNumber = '(' +numberArray.slice(-10, -7).join('') + ') ' + formattedNumber;

                let code = number.replace(number.slice(-10), '');
                if (code.length > 0) {
                    formattedNumber = code + ' ' + formattedNumber;
                } else {
                    formattedNumber = '1 ' + formattedNumber;
                }

                formattedNumber = '+' + formattedNumber;

                return formattedNumber;
            }
        }

        function formatAllNumbers() {
                document.querySelectorAll("[data-number-formatted]").forEach(function (element, index) {
                    element.innerText = formatNumber(element.dataset.numberFormatted);
                });
        }

    window.onload = function() {
        formatAllNumbers();
    };

        window.formatAllNumbers = formatAllNumbers;

})(window);
